<template>

  <div id="SchoolCard" class="wrap" >
     <!-- Login or Signup Dialog -->
      <v-dialog
        v-model="signupLoginDialog"
        max-width="400"
        persistent
        >
        <v-card style="borderRadius:5px">
          <v-card-title class="title grey lighten-2 text-xs-center">You Need an Account <v-spacer></v-spacer> <v-icon @click="signupLoginDialog = false" color="red">mdi-close</v-icon></v-card-title>
          <v-card-text class=" mt-2" >
            You need to Login or Signup before you can save this school to your dashboard
          </v-card-text>


          <v-card-actions class="pb-2 ">
            <v-layout class="justify-center">
            <v-btn to="/LoginSignupPage" style="width:48%"  class="elevation-0 mx-2" color="green" dark @click="showCreateSubscriptionDialog = false">
              Login
            </v-btn>
            <v-btn to="/signup" style="width:48%"  class="elevation-0" color="primary" @click="showCreateSubscriptionDialog = false">
              Signup
            </v-btn>
            </v-layout>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Need Active Subscription Dialog -->
      <v-dialog
        v-model="showCreateSubscriptionDialog"
        max-width="400"
        persistent
        style="zIndex:2000"
        >
        <v-card style="borderRadius:5px">
          <v-card-title class="title grey lighten-2 text-xs-center">You need a subscription <v-spacer></v-spacer> <v-icon @click="showCreateSubscriptionDialog = false" color="red">mdi-close</v-icon></v-card-title>
          <v-card-text class="text-xs-justify mt-2" >
            You need an active subscription before you can save this school to your dashboard.
          </v-card-text>


          <v-card-actions class="py-1 pb-2">
            <v-btn to="/myaccount" block class="elevation-0" color="primary" @click="showCreateSubscriptionDialog = false">
              My Account
            </v-btn>

            <!-- <v-btn  class="elevation-0" color="error" @click="showCreateSubscriptionDialog = false">
              Close
            </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- School saved to dashboard alert -->
      <v-snackbar
        v-model="savedSchoolalert"
        color="success"
        top
        >
        <span class="subheading">School Saved to your <v-icon class="mb-1" color="white" small>mdi-view-dashboard</v-icon> Dashboard  </span>

        <v-btn
          dark
          text
          @click="savedSchoolalert= false"
        >
          X Close
        </v-btn>
      </v-snackbar>
      
      <div class="maxContainer ">
        <!-- Mobile Bar -->
        <v-app-bar  prominent class=" white d-md-none" fixed  elevate-on-scroll height={this.fixedHeaderFixerVal}>
          <v-layout  class="mt-1 justify-center align-center"   column   ref="fixedHeaderFixer">
              <v-layout row  class="justify-center align-center">
                <span v-bind:class="{ 'mt-4' : school.school_name.length >= 25 }" class=" headline font-weight-medium text-center light-blue--text text--darken-4 ">
                  {{ school.school_name }}
                </span>
              </v-layout>

              <v-layout  class="my-3 justify-center align-center" row >
                <v-layout >
                  <Report/>
                </v-layout>

                  <v-layout >
                    <v-btn v-if="schoolAlreadySaved"  dark color="grey lighten-3 " class="mt-1 elevation-0 ml-5" id="buttonShadow"> <v-icon  small color="green" class="mr-1">mdi-bookmark</v-icon> <span class="green--text">Saved</span></v-btn>
                    <v-btn v-else @click="saveSchool"   dark color="green"  class="mt-1 elevation-6 ml-5" > <v-icon  small class="mr-1">mdi-bookmark</v-icon> Save</v-btn>
                </v-layout>
              </v-layout>

          </v-layout>
        </v-app-bar >
        <div class="headerFake">
          <div class="maxContainer  hidden-sm-and-down">
            <div @click="back" class="headerFake__back">
              <a class="headerFake__backLink">
                <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
                <span class="headerFake__backText">Back</span>
              </a>
            </div>

            <v-toolbar-title class="mb-3">{{ school.school_name }}</v-toolbar-title>

            <div class="flex-grow-1"></div>


              <Report/>

              <v-btn v-if="schoolAlreadySaved"  dark color="grey lighten-3 " class="mt-1 elevation-0 ml-5" id="buttonShadow"> <v-icon  small color="green" class="mr-1">mdi-bookmark</v-icon> <span class="green--text">Saved</span></v-btn>
              <v-btn v-else @click="saveSchool"   dark color="green"  class="mt-1 elevation-6 ml-5" > <v-icon  small class="mr-1">mdi-bookmark</v-icon> Save</v-btn>


             <div class="headerFake__buttonCover">
              <v-btn
                fab
                small
                color="white"
                :href="`tel:${school.program_phone_number}`"
              >
                <v-icon color="blue darken-3" >mdi-phone-outline</v-icon>
                <span class="caption grey--text mt-1">Phone</span>
              </v-btn>

             <v-btn
              fab
              small
              color="white"
              :href="`mailto:${school.program_email}`"
            >
              <v-icon color="blue darken-3">mdi-email-outline</v-icon>
              <span class="caption grey--text mt-1">E-mail</span>
            </v-btn>

            <v-btn
              fab
              small
              color="white"
              @click="showAddressDialog = true"
            >
              <v-icon color="blue darken-3">mdi-map-marker-outline</v-icon>
              <span class="caption grey--text mt-1">Address</span>
            </v-btn>

             <v-btn
              fab
              small
              color="white"
              :href="school.program_website"
              target="_blank"
            >
              <v-icon color="blue darken-3">mdi-monitor</v-icon>
              <span class="caption grey--text mt-1">Website</span>
            </v-btn>
            </div>
          </div>
        </div>
          <!-- <div class="fixBannerPos">
            <div class="maxContainer">
              <banner />
            </div>
          </div> -->

        <v-container  pt-0 pl-0 pr-0>
          
          <v-row>
            <v-col lg="12">
            <v-tabs
            v-model="tab"
            background-color="transparent"
            hide-slider
            grow
            :style="{marginTop: this.spacingTop}"
            >
            <v-tab active-class="grey darken-3 white--text" style="marginLeft:0px;">
              <v-icon class="mr-2" small>mdi-information</v-icon>
               Info

            </v-tab>
          
            <v-tab active-class="grey darken-3 white--text">
               <v-icon class="mr-2" small>mdi-chart-line</v-icon>
               Requirements
            </v-tab>
              <v-tab active-class="grey darken-3 white--text" v-if="faqs.length">
               <v-icon class="mr-2" small>mdi-frequently-asked-questions</v-icon>
               FAQ
            </v-tab>
            <v-tab active-class="grey darken-3 white--text">
               <v-icon class="mr-2" small>mdi-message-reply-text</v-icon>
               Messages
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item  style="marginBottom:30px">

              <v-layout class="hidden-md-and-up mt-3">
                <!-- Phone Number -->
                  <v-layout column class="align-center justify-center" >
                    <a :href="`tel:${school.program_phone_number}`">

                        <v-btn small icon  color="light-blue darken-3">  <v-icon color="light-blue darken-3">mdi-phone-outline</v-icon></v-btn>
                    </a>
                    <span class="caption grey--text mt-1">Call</span>
                  </v-layout>

                  <!-- Email -->
                  <v-layout column class="align-center justify-space-between" >
                    <a :href="`mailto:${school.program_email}`">
                      <v-btn  icon small   color="light-blue darken-3"> <v-icon color="light-blue darken-3">mdi-email-outline</v-icon>
                      </v-btn>
                    </a>
                    <span class="caption grey--text mt-1">Email</span>
                  </v-layout>

                  <!-- Address -->
                  <v-layout column class="align-center justify-center">
                    <v-btn @click="showAddressDialog = true" icon small  > <v-icon color="light-blue darken-3">mdi-map-marker-outline</v-icon></v-btn>
                    <span class="caption grey--text mt-1">Address</span>
                  </v-layout>

                  <!-- Address Dialog -->
                  <v-dialog
                    v-model="showAddressDialog"
                    scrollable
                    max-width="400"
                    persistent
                    style="zIndex:2000"
                    >
                    <v-card>
                      <v-card-title class="title light-blue darken-3 text-xs-center white--text">
                        <v-icon color="white" large class="mr-3">mdi-map-marker-outline</v-icon>
                        Program Address
                      </v-card-title>

                      <v-card-text class="text-xs-justify pb-0 mt-2" >
                        <v-layout column  pl-2>
                          <p class=" subheading mb-1 black--text"> {{school.program_address}}</p>
                          <p class=" subheading mb-1 black--text"> {{school.program_city}}, {{school.program_state}}</p>
                          <p class=" subheading mb-1 black--text"> {{school.program_zip_code}}</p>
                        </v-layout>
                      </v-card-text>

                      <v-card-actions class="pb-2  ">
                        <v-spacer></v-spacer>
                        <v-btn
                          color="red"
                          block
                          dark
                          class="elevation-0"
                          @click="showAddressDialog = false"
                        >
                          Close
                        </v-btn>
                      </v-card-actions>

                    </v-card>
                  </v-dialog>

                  <!-- SCHOOL WEBSITE -->
                  <v-layout column class="align-center justify-center">
                      <a :href="school.program_website" target="_blank">
                      <v-btn  icon small   > <v-icon color="light-blue darken-3">mdi-monitor</v-icon></v-btn>
                      </a>
                      <span class="caption grey--text mt-1">Website</span>
                  </v-layout>
              </v-layout>



              <!-- Accreditation -->
              <v-card  flat id="buttonShadow" class="mt-6">
                <v-layout   class="grey lighten-4 pb-2 align-center justify-center">
                  <span class="title font-weight-regular  align-center mt-1">Accreditation Status   <v-icon @click="showStatusDialog = true" small class="ml-1 mb-1">mdi-information</v-icon> </span>
                </v-layout>

                <v-layout column class="justify-center align-center mt-1 mb-1  pb-4 pt-2">
                  <span class="title"><span  :class="{ 'red--text' : school.accreditation_status === 'Withheld', 'amber--text text--darken-3' : school.accreditation_status === 'Probationary', 'blue--text text--lighten-1' : school.accreditation_status === 'Provisional', 'green--text' : school.accreditation_status === 'Continued', 'grey--text' : school.accreditation_status === 'Developing-Not Accredited' }">{{school.accreditation_status}}</span></span>
                </v-layout>
              </v-card>
              <!-- Accredidation Dialog Status -->
              <v-dialog
                v-model="showStatusDialog"
                scrollable
                max-width="400"
                persistent
                style="zIndex:2000"
                >
                <v-card style="borderRadius:10px" >
                  <v-card-title class="title grey lighten-2 text-xs-center mb-2">
                    Accredidation - {{school.accreditation_status}}
                  </v-card-title>
                  <v-card-text class="text-xs-justify mt-1"  v-if="school.accreditation_status === 'Continued'">
                    Accreditation-Continued is granted 1) when a currently accredited program is in compliance with the Standards, 2) in the case of a program holding Accreditation-Probation when the program has demonstrated that it is once again in compliance with the Standards, or 3) when a program holding Accreditation-Provisional demonstrates compliance with the Standards after completion of the provisional review process. Accreditation-continued status remains in effect until the program closes or withdraws from the accreditation process or until accreditation is withdrawn for failure to comply with the Standards.
                  </v-card-text>

                  <v-card-text class="text-xs-justify mt-1" v-if="school.accreditation_status === 'Provisional'">
                    Accreditation–Provisional is an accreditation status granted when the plans and resource allocation, if fully implemented as planned, of a proposed program that has not yet enrolled students appear to demonstrate the program’s ability to meet the ARC-PA Standards or when a program holding accreditation-provisional status appears to demonstrate continued progress in complying with the Standards as it prepares for the graduation of the first class (cohort) of students.
                  </v-card-text>

                  <v-card-text class="text-xs-justify mt-1" v-if="school.accreditation_status === 'Probationary'">
                    Accreditation-Probation is a temporary, status of accreditation, limited to two years, granted when a program holding an accreditation status of accreditation-provisional or accreditation-continued does not meet the Standards and when the capability of the program to provide an acceptable educational experience for its students is threatened.  Once placed on probation, a program that fails to comply with accreditation requirements in a timely manner, as specified by the ARC-PA, may be scheduled for a focused site visit and/or risk having its accreditation withdrawn.
                  </v-card-text>

                  <v-card-text class="text-xs-justify mt-1" v-if="school.accreditation_status === 'Administrative Probation'">
                  Accreditation-Administrative Probation is a temporary status granted when a program has not complied with an administrative requirement, such as failure to pay fees or submit required reports. Once placed on Administrative Probation, a program that fails to comply with administrative requirements in a timely manner, as specified by the ARC-PA, may be scheduled for a focused site visit and/or risk having its accreditation withdrawn.
                  </v-card-text>

                  <v-card-text class="text-xs-justify mt-1" v-if="school.accreditation_status === 'Withheld'">
                  Accreditation Withheld is a status granted when a PA program, seeking accreditation-provisional is not in compliance with the Standards. The program receiving this accreditation status may voluntarily withdraw from the accreditation process within the 30-day appeal timeframe.
                  </v-card-text>

                  <v-card-text class="text-xs-justify mt-1" v-if="school.accreditation_status === 'Developing-Not Accredited'">
                  The PA Program is working towards accreditation, but has not yet passed ARC-PA accreditation review. There is no guarantee the program will be accredited.
                  </v-card-text>

                  <v-card-text class="text-xs-justify mt-0 pt-0" >
                  <span>You can read more about PA School accreditation status at <a href="http://www.arc-pa.org/accreditation/accreditation-types-review-cycle/" class="blue--text  " target="_blank">ARC-PA Accreditation Types and Review </a></span>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn @click="showStatusDialog = false"  block color="red" dark  class="elevation-0">Close</v-btn>
                  </v-card-actions>

                </v-card>
              </v-dialog>

              <!-- Program Information -->
              <v-card flat class="mt-6">
                <ProgramInfo :school="school"/>
              </v-card>

              <!-- Application -->
              <v-card flat class="mt-6" >
                <Application :school="school"/>
              </v-card>

              <v-card v-if="school.preprofessional_degree_required" class="mt-4" flat>
                  <PrePaTrack :school="school"/>
              </v-card>

              <v-card v-if="school.high_school_entry" class="mt-4" flat >
                <HighSchoolEntry :school="school"/>
              </v-card>

              <!-- Program Information -->
              <v-card v-if="school.mission_statement" flat class="mt-6">
                <MissionStatement :school="school"/>
              </v-card>

              
            </v-tab-item>
            <v-tab-item style="marginBottom:20px">
              <v-card class="mt-4" flat>
                  <AdmissionRequirements :school="school"/>
              </v-card>

               <v-card v-if="school.notes" class="mt-4"   >
                  <Notes :school="school"/>
                </v-card>

              
            </v-tab-item>

            <v-tab-item>
              <hyvor-comments :id="school.id" />
            </v-tab-item>

            <v-tab-item v-if="faqs.length">
              <v-expansion-panels focusable class="px-2 mt-8 ">

                <!--<v-select
                  :items="faqCatgories"
                  item-text="name"
                  item-value="id"
                  v-model="faqCategoryFilter"
                  label="Filter by Category"
                  solo
                ></v-select>-->
                <div class="filterSpacerCover">
                  <ul class="filterSpacer">
                    <li v-for="faqCategory in faqCatgories" :key="faqCategory.id" class="filterSpacer__li">
                      <v-btn medium rounded :class="[faqCategoryFilter == faqCategory.id ? 'primary' : '']" @click="faqCategoryFilter = faqCategory.id" >
                        {{faqCategory.name}}
                      </v-btn>
                    </li>
                  </ul>
                </div>
                <div v-if="faqCategoryFilter" class="filterSpacerCoverReset">
                  <v-btn medium @click="faqCategoryFilter = null" class="">
                    <v-icon>mdi-close</v-icon> Reset
                  </v-btn>
                </div>

                <v-text-field
                  label="Solo"
                  clearable
                  v-model="searchFaq"
                  placeholder="Search"
                  solo
                ></v-text-field>

                <v-expansion-panel class="mt-2" v-for="faq in visibleFaqs" :key="faq.index">
                  <v-expansion-panel-header  class="light-blue--text text--darken-4">
                    <v-layout row align-center pb-0 pr-8 v-html="faq.question"></v-layout>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager class="p-4 mx-0 pb-0 elevation-0 ">
                    <div class="py-4" v-html="faq.answer"></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div class="px-4" v-if="visibleFaqs.length == 0">no results founds...</div>
            </v-tab-item>
          </v-tabs-items>
            </v-col>
          </v-row>
          <v-alert type="info" outlined text dense style="marginBottom:0px; marginTop:0px">
                <span>Information is subject to change by the PA program at any time. If you notice an error please report it to us by clicking the "Report" button above". Thank you for helping us keep myPAbox the most reliable resource for the pre-PA community. - myPAbox Team</span>
                
              </v-alert>




        </v-container>
        </div>










      <v-btn  class="mr-4 ml-2  fixed elevation-0 d-md-none " style="zIndex:1" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>

      </div>


  </div>

</template>

<script>
import moment from 'moment'
import schoolMixin from '@/mixins/schoolmixin'
import { Card, createToken } from 'vue-stripe-elements-plus'
import * as firebase from 'firebase'
import axios from 'axios'
import HyvorComments from '@/components/HyvorComments'
import Banner from '@/components/Banner/Banner'

export default {
  name: 'SchoolDetail',
  mixins: [schoolMixin],
  data() {
    return {
      searchFaq: '',
      faqCategoryFilter: null,
      faqs: [],
      alert: false,
      tab: null,
      savedSchoolalert: false,
      schoolAlreadySavedAlert: false,
      alreadySaved: false,
      e1: true,
      e2: true,
      step: 1,
      valid: '',
      showStatusDialog : false,
      showAddressDialog: false,
      showCreateSubscriptionDialog: false,
      signupLoginDialog: false,
      schoolSaved: false,
      fixedHeaderFixerVal: 100,
      spacingTop: 0,
    };
  },


  methods: {
    signUp () {
      this.emailErrorMessage = []
      this.passwordErrorMessage = []
      this.agreementErrorMessage = []
      this.confirmPasswordErrorMessage = []


      if(this.password !== this.confirmPassword) {
        this.confirmPasswordErrorMessage.push('passwords do not match')
      }

      if(this.agreement === false) {
        this.agreementErrorMessage.push('Please check the box to continue')
      }
       firebase.auth().createUserWithEmailAndPassword( this.email, this.password)
      .then(
        cred => {
          console.log(cred)
          const uid = cred.user.uid

          const newUser = {
            name: this.name,
            id: uid,

          }
          // commit('setUser', newUser)


          firebase.database().ref('users').child(uid).set(newUser)

          .then((data) => {
            // firebase.database().ref('/users/' + getters.user.id).update({amount: this.amount, token: payload.token})
          this.showCreditCard = true
          })
          .catch((error) => {
            console.log(error)
            })
        },
      )
      .catch(
        error => {
          if(error.message === "The email address is already in use by another account.") {

            this.emailErrorMessage.push(error.message)


          }
          if(error.message === "The email address is badly formatted.") {

            this.emailErrorMessage.push(error.message)


          }
          if(error.message === "Password should be at least 6 characters" || error.message === "The password must be 6 characters long or more.") {
            console.log(error.message)
            this.passwordErrorMessage.push(error.message)
            console.log(this.passwordErrorMessage)

          }
          console.log(error)

        }
      )
    },
    showCreateAccount () {

      this.createAccount = true
      console.log(this.createAccount)
    },
    back() {
      this.$router.go("-1");
    },
    saveSchool() {
      console.log('save clicked')
      if (this.user === undefined || this.user === null) {
        console.log('no user')
        this.signupLoginDialog = true
      }

      if(this.user.subscriptions === undefined || this.user.subscriptions === null) {
        console.log('user does not have subscriptions')
        this.showCreateSubscriptionDialog = true
      }

      else {

          this.$store.dispatch("setSaveSchool", this.school).then(() => {
          this.savedSchoolalert = true;
          });
        }
      },
    showStatusInfo () {
      this.showStatusDialog = true
    },
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    school() {
      const findSchool = this.schools.find(school => school.school_name.split('-').join(' ') === this.$route.params.id.split('-').join(' '));
      
      return findSchool
     
    },
    user() {
      return this.$store.getters.user;
    },
    schools() {
        return this.$store.getters.loadedSchools
      },
    savedSchools() {
      return this.$store.getters.savedSchools;
    },
    schoolAlreadySaved() {

      return this.savedSchools.findIndex(savedSchool => {
        if(savedSchool.id === this.school.id) {
          console.log('school already saved')
          return true
        }

      }) >= 0

    },

     error() {
      return this.$store.getters.error
    }

  },
  mounted(){
    this.fetchFaqs()
    this.fixedHeaderFixerVal = this.$refs.fixedHeaderFixer.scrollHeight + 10
    this.spacingTop = this.fixedHeaderFixerVal > 125 ? '80px' : '40px'

    document.querySelector('.v-slide-group__prev--disabled').style.flexBasis = 0
    document.querySelector('.v-slide-group__prev--disabled').style.minWidth = 0
  },
  components: {
    HyvorComments,
    Card,
    Banner
  }
};
</script>

<style scoped>

.school{
  line-height: 1.8;
  margin-top: 30px;
}
.card {
  padding-top: 10px;

  background-color: rgb(255, 255, 255);
}

a {
  text-decoration: none;
}
.schoolName {
  font-size: 20px;
}

.toolbarContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}




.background {

  background-color: rgb(255, 255, 255);
}
 .card--flex-toolbar {
    margin-top: -64px;
  }

hr {
  position:absolute;
  width:80%;
  margin-top: 35px;
  opacity: .5;
}


.container {
  display:flex;
  flex-direction: column;
  justify-content: center;

}

.blueHeading {
  color:rgb(54, 54, 54);
}

#schoolCard {
  margin-top:20px;
  z-index: 1;
}

#icons {
  width:30px;
  height:30px;
}

.schoolList {
  margin-top:60px;
  margin-bottom: 45px;
}

.closeButton {
  bottom: 0;
  right: 0;
  position: fixed;

}

.tileCard {
  border-radius: 10px;
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

#schoolToolbar {
  position: sticky;
  box-shadow: 0 10px 30px -10px #11111130;

}

 #buttonShadow {

  box-shadow: 0 10px 30px -10px #11111130;
}

.buttonShadow {

  box-shadow: 0 10px 30px -10px #11111130;
}

#backButton {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
 z-index: 5000;
}

a {
  text-decoration: none;
}

   .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:60px;

  }

  .roundContainer {
    border-radius: 10px;
  }

  .v-messages__message {
    color: yellowgreen;
  }

  .container {
    /* display:flex;
    flex-direction: column;
    align-items:center;
    justify-content: center; */
    margin-top:20px;
  }

  .stripe-card {
    width: 350px;
    border: 1px solid rgb(187, 187, 187);
    border-radius: 12px;
    padding: 10px;

  }
.stripe-card.complete {
  border-color: rgb(3, 81, 145);
}

.promoCode {
   border: 1px solid rgb(187, 187, 187);
   border-radius: 12px;
   margin-bottom:20px;
   padding-left:10px;
   padding-top:10px;
   padding-bottom:10px;
   outline: none;
   font-size: 18px;


}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}
.headerFake {
  position: relative;
  text-align: center;
}

@media (min-width: 960px) {
  .headerFake .v-toolbar__title {
    font-size: 30px;
    padding-bottom: 12px;
  }
}


.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
  .container {
    max-width: 60%;
  }
}
.headerFake #Report {
  display: inline-block;
  vertical-align: middle;
}
.headerFake__buttonCover {
  padding: 30px 0 10px;
}
.headerFake__buttonCover .v-btn .caption {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
}
.headerFake__buttonCover .v-btn + .v-btn{
  margin-left: 40px;
}

@media (max-width: 1044px) {
  .fixBannerPos {
    max-width: 525px;
    margin: 24px auto 0;
  }
}

@media (min-width: 1045px) {
  .fixBannerPos {
    position: fixed;
    top: 170px;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
}
.filterSpacerCover {
  display: block;
  width: 100%;
}
.filterSpacerCoverReset {
  display: block;
  width: 100%;
  text-align: right;
  margin: 0 0 20px;
}

.filterSpacer {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0 0 20px;
  width: 100%;

}

.filterSpacer__li {
  margin: 10px;
}

.wrap {
  margin-top:8vh;
}
@media (min-width: 900px) {
  .wrap {
    margin-top: 8vh !important;
    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Schools/SchoolDetail/SchoolDetail.vue